const first_timeout = 5 * 1000;
const final_timeout = 20 * 1000;
let first_log = false;
let newrelic = window.newrelic;
function checkForCheckout($) {
    const trouble_loading = $(`<h2>Loading...</h2><p>We are having some trouble loading checkout. Please wait a moment longer.</p>`);
    const couldnot_load = $(`<h2>Error</h2><p>Error loading checkout, please try again in a few minutes.</p><p>You may <a href="/contact-us/">contact us</a> if you need additional assistance.</p>`);
    if(window.location.pathname.indexOf('checkout') > -1) {
        let time = new Date();
        let interval = window.setInterval(() => {
            let checkout = document.getElementById('bc-embedded-checkout');
            if(checkout && checkout.getElementsByTagName('iframe').length === 0) {
                let offset = new Date() - time;
                if(offset < final_timeout ) {
                    $('.entry-body-content').prepend(trouble_loading);
                    if(newrelic !== undefined && first_log === false) {
                        first_log = true;
                        newrelic.noticeError(`Checkout - Unable to load cart after ${offset / 1000} seconds`);
                    }
                }
                else {
                    clearInterval(interval);
                    trouble_loading.remove();
                    $('.entry-body-content').prepend(couldnot_load);
                    if(newrelic !== undefined) {
                        newrelic.noticeError('Checkout - Unable to load cart after ${offset / 1000} seconds');
                    }
                }
            }
            else {
                clearInterval(interval);
                trouble_loading.remove();
                couldnot_load.remove();
            }
        
        }, first_timeout);
    }
}

export default checkForCheckout;
